<template>
	<div class="lease">
		<div class="lease_container" v-if="!lease_container">
			<div class="lease_list" v-for="item in list">
				<div class="lease_list_top">
					<div class="lease_list_left" :style="'background: url('+item.goodsurl+') center center no-repeat;background-size: cover;'">

					</div>
					<div class="lease_list_content">
						<div class="lease_list_name">{{item.goodsname}}</div>
						<div class="lease_list_num">租用时间：{{item.createtime}}</div>
						<div class="lease_list_Number">租赁个数：{{item.leasenum}}</div>
					</div>
				</div>
				<div class="lease_list_bottom">
					<div class="lease_list_bottom_left">
						<div class="lease_list_bottom_name">租赁人姓名：{{item.reamname}}</div>
						<div class="lease_list_bottom_id">租赁人身份证号：{{item.idcard}}</div>
					</div>
					<div class="lease_list_bottom_right">
						<div v-if="item.status==1" class="lease_list_right_one">
							租赁中
						</div>
						<div v-if="item.status==2" class="lease_list_right_two">
							已完成
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="lease_container_no" v-if="lease_container">暂无租赁</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'MyLease',
		data() {
			return {
				baseUrl: "",
				list: [],
				lease_container: false,
				access_token: ""
			}
		},
		methods: {
			lease_cli(goodsid) {
				var that = this;
				sessionStorage.setItem('goodsid', goodsid);
				that.$router.push({
					name: "LeaseInformation"
				})
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
			}
			that.baseUrl = baseUrl;
			that.access_token = localStorage.getItem('access_token')
			wclient.view.showLoading();
			wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
			wclient.ajax({
				type: "GET",
				url: that.baseUrl + '?ugi=leasegoods&action=leaseingList',
				dataType: "json",
				async: true,
				data: {
					access_token: that.access_token
				},
				success: function(data) {
					wclient.view.hideLoading();
					if(data.code == 'A00006') {
						if(data.list.length == 0) {
							that.lease_container = true;
						} else {
							that.list = data.list;
							for(var i = 0; i < that.list.length; i++) {
								that.list[i].idcard = that.list[i].idcard.replace(/(.{3}).*(.{3})/, "$1********$2")
							}
						}
					}
				}
			});
		}
	}
</script>

<style scoped>
	.lease {
		width: 100%;
		-webkit-overflow-scrolling: touch;
	}
	
	.lease_container {
		width: 100%;
		padding-top: 10px;
	}
	
	.lease_list {
		width: 90%;
		margin: 0 auto 10px;
		background: white;
		padding: 10px;
	}
	
	.lease_list_top {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	
	.lease_list_left {
		width: 70px;
		height: 70px;
	}
	
	.lease_list_content {
		width: 72%;
	}
	
	.lease_list_name {
		font-size: 16px;
		color: #525252;
	}
	
	.lease_list_num {
		color: #A4A4A4;
		font-size: 14px;
	}
	
	.lease_list_Number {
		color: #A4A4A4;
		font-size: 14px;
	}
	
	.lease_list_right_one {
		background: #D72B27;
		color: #FEFEFE;
		font-size: 12px;
		border-radius: 20px;
		height: 20px;
		line-height: 20px;
		padding: 4px 10px;
		margin-top: 15px;
		text-align: center;
	}
	
	.lease_list_right_two {
		background: #C6C6C6;
		color: #FEFEFE;
		font-size: 12px;
		border-radius: 20px;
		height: 20px;
		line-height: 20px;
		padding: 4px 10px;
		margin-top: 15px;
		text-align: center;
	}
	
	.lease_container_no {
		width: 100%;
		font-size: 20px;
		line-height: 150px;
		text-align: center;
	}
	
	.lease_list_bottom {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.lease_list_bottom_left{
		width: 72%;
	}
	.lease_list_bottom_right{
		width: 23%;
	}
	.lease_list_bottom_name {
		width: 100%;
		margin-top: 10px;
		font-size: 14px;
		color: #A4A4A4;
	}
	
	.lease_list_bottom_id {
		width: 100%;
		font-size: 14px;
		color: #A4A4A4;
	}
</style>


// WEBPACK FOOTER //
// src/components/MyLease.vue